document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('[data-description-wrapper]');




  wrappers.forEach(function (wrapper) {

    const content = wrapper.querySelector('[data-description-content]');
    const button = wrapper.querySelector('[data-description-see-more]');
    const buttonLess = wrapper.querySelector('[data-description-see-less]');
    const buttonText = button ? button.querySelector('span') : null;

    if (!content || !button || !buttonLess || !buttonText) return;

    const collapsedHeight = window.innerWidth <= 749 ? 180 : 220;
    const fullHeight = content.scrollHeight;

    if (fullHeight <= collapsedHeight + 20) {
      button.classList.add('is-hidden');
      content.style.maxHeight = 'none';
      return;
    }

    let currentHeight = collapsedHeight;
    updateButtonLess();
    updateButtonMore();
    content.style.maxHeight = collapsedHeight + 'px';
    buttonText.textContent = 'Ver mais';
    button.setAttribute('aria-expanded', 'false');

    button.addEventListener('click', function () {
      if (currentHeight < fullHeight) {
        currentHeight += 1000; /*Quantidade de pixels que irá descer a página*/ 
        if (currentHeight > fullHeight) {
          currentHeight = fullHeight;
        }
      }
      content.style.maxHeight = currentHeight + 'px';
      updateButtonLess();
      updateButtonMore();
    });

    buttonLess.addEventListener('click', function () {
      currentHeight -= 1000; /*Quantidade de pixels que irá subir a página*/ 
      if (currentHeight < collapsedHeight) {
        currentHeight = collapsedHeight;
      }
      content.style.maxHeight = currentHeight + 'px';
      updateButtonLess();
      updateButtonMore();
      
    });

    function updateButtonLess() {
      if (currentHeight > collapsedHeight) {
        buttonLess.classList.remove('is-hidden');
      } else {
        buttonLess.classList.add('is-hidden');
      }
    }

    function updateButtonMore() {
      if (currentHeight >= fullHeight) {
        button.classList.add('is-hidden');
      } else {
        button.classList.remove('is-hidden');
      }
    }

  });
});